import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ReceiptText } from "lucide-react";
import { api } from "../lib/api";

export default function OrderVault() {
  const { slug } = useParams();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/customer/orders"); setOrders(data); } catch { /* noop */ }
    })();
  }, []);

  return (
    <div className="min-h-screen" style={{ background: "var(--bg)", color: "var(--fg)" }}>
      <header className="glass sticky top-0 z-30 border-b" style={{ borderColor: "var(--border)" }}>
        <div className="max-w-3xl mx-auto flex items-center gap-3 px-4 py-3">
          <Link to={`/r/${slug}`} className="p-2 rounded-full hover:opacity-80" data-testid="vault-back" style={{ background: "var(--glass-light)" }}><ArrowLeft className="w-5 h-5" /></Link>
          <div>
            <div className="text-[10px] uppercase tracking-widest font-mono" style={{ color: "var(--fg-muted)" }}>Digital Order Vault</div>
            <div className="font-display text-xl">Every craving you've had here</div>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6 space-y-4">
        {orders.length === 0 && (
          <div className="text-center py-16" style={{ color: "var(--fg-muted)" }}>
            <ReceiptText className="w-8 h-8 mx-auto" style={{ color: "var(--accent)" }} />
            <p className="mt-4">No orders yet. Your vault will fill up after your first bite.</p>
          </div>
        )}
        {orders.map((o) => (
          <div
            key={o.id}
            className="p-4 rounded-2xl"
            style={{ border: "1px solid var(--border)", background: "var(--bg-card)" }}
            data-testid={`vault-order-${o.id}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="text-[11px] font-mono uppercase tracking-widest" style={{ color: "var(--fg-muted)" }}>
                  #{o.id.slice(0, 8)} · {new Date(o.created_at).toLocaleDateString()}
                </div>
                <div className="font-display text-lg">{o.items.length} items · Table {o.table_no}</div>
              </div>
              <span
                className="text-xs px-2 py-1 rounded-full font-mono uppercase tracking-widest"
                style={
                  o.paid
                    ? { background: "rgba(16,185,129,0.15)", color: "rgb(16,185,129)" }
                    : { background: "var(--glass-light)", color: "var(--fg-muted)" }
                }
              >
                {o.status}
              </span>
            </div>
            <div className="mt-3 space-y-1 text-sm" style={{ color: "var(--fg-muted)" }}>
              {o.items.map((i, idx) => (
                <div key={`${i.item_id}-${idx}`} className="flex justify-between">
                  <span>{i.qty}× {i.name}</span>
                  <span className="font-mono">₹{(i.price * i.qty).toFixed(0)}</span>
                </div>
              ))}
            </div>
            <div className="border-t mt-3 pt-2 flex justify-between font-display" style={{ borderColor: "var(--border)" }}>
              <span>Total</span><span className="gold-text">₹{o.total.toFixed(0)}</span>
            </div>
          </div>
        ))}
      </main>
    </div>
  );
}
